export function useMessagingDisclosure(partnerId?: string) {
  // Simplified hook - no localStorage, just returns basic functions
  const acknowledgeDisclosure = () => {
    // No longer storing in localStorage - just returns true for success
    return true;
  };

  const shouldShowDisclosure = () => {
    // Always show disclosure when enabling messaging (no localStorage check)
    return true;
  };

  const canEnableMessaging = () => {
    // Always can enable after disclosure is acknowledged
    return true;
  };

  return {
    hasAcknowledged: false,
    hasDismissed: false,
    isLoading: false,
    acknowledgeDisclosure,
    shouldShowDisclosure,
    canEnableMessaging,
  };
}
